import { Drawer } from 'antd';
import styled from 'styled-components';

export const StyledDrawer = styled(Drawer)`
  .select-drawer-header {
    padding: ${({ theme: { token } }) => token.padding}px;
  }
  .select-drawer-footer {
    padding: ${({ theme: { token } }) => token.padding}px;

    .select-drawer-footer-button {
      width: 100%;
    }
  }
`;
